<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
(function() {
    // 1. LIJST MET TE VERWIJDEREN TEKSTEN
    // Voeg hier simpelweg tekst toe die je nergens wilt zien
    const forbiddenTexts = ['(Nash)', '(lpen)', '(Geen)'];

    // 2. UITGEBREIDE SELECTORS VOOR DE HELE SHOP
    const selectors = [
        '.cart-item-variant',           // Winkelwagen variant tekst
        '[data-header-option]',         // Shopify Product-optie koppen (Kleur: Blauw...)
        '.cart-item__option',           // Standaard Shopify cart
    ].join(', ');

    // 3. UNIVERSELE CSS
    const style = document.createElement('style');
    style.innerHTML = `
        ${selectors} {
            visibility: hidden !important;
            position: relative;
        }

        ${selectors.split(',').map(s => s.trim() + '::before').join(', ')} {
            visibility: visible !important;
            position: absolute;
            left: 0;
           top: -2px;
            content: attr(data-clean-name);
            white-space: nowrap;
            pointer-events: none;
        }

        /* Specifieke correctie voor swatches (labels die alleen een kleur-bolletje hebben) */
        .product-form__label::before {
            content: none !important; /* Voorkom dat er tekst verschijnt bovenop de kleur-swatch */
        }
        
        /* Winkelwagen omloop toestaan */
        .cart-item-variant::before, .cart-item__option::before {
            white-space: normal !important;
        }
    `;
    document.head.appendChild(style);

    const applyUniversalFix = () => {
        document.querySelectorAll(selectors).forEach(el => {
            // Haal tekst op uit OPTION of textContent
            let originalText = (el.tagName === 'OPTION') ? el.text : el.textContent;
            
            // Soms bevatten labels alleen witruimte of een image, die negeren we
            if (!originalText || originalText.trim().length === 0 || originalText.includes('Edit design')) return;

            let cleanName = originalText;
            let needsUpdate = false;

            forbiddenTexts.forEach(forbidden => {
                if (cleanName.includes(forbidden)) {
                    // Verwijder het verboden woord overal waar het voorkomt
                    const escaped = forbidden.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    cleanName = cleanName.replace(new RegExp(escaped, 'g'), '').replace(/\s\s+/g, ' ').trim();
                    needsUpdate = true;
                }
            });

            if (el.tagName === 'OPTION') {
                if (el.text !== cleanName) el.text = cleanName;
            } else {
                if (el.getAttribute('data-clean-name') !== cleanName) {
                    el.setAttribute('data-clean-name', cleanName);
                }
            }
        });
    };

    // --- TRIGGERS ---
    applyUniversalFix();
    setInterval(applyUniversalFix, 250);

    document.addEventListener('click', () => {
        setTimeout(applyUniversalFix, 50);
        setTimeout(applyUniversalFix, 300);
    });

    const observer = new MutationObserver(() => applyUniversalFix());
    observer.observe(document.body, { 
        childList: true, 
        subtree: true,
        characterData: true 
    });
})();

(function() {
    // 1. De centrale functie die tekst opschoont
    const removeBrackets = (element) => {
        if (!element || !element.textContent) return;
        
        // Regex uitleg: 
        // \s* -> pakt eventuele spaties voor het haakje
        // \(     -> zoekt het haakje openen
        // [^)]* -> pakt alle tekens die GEEN sluit-haakje zijn
        // \)     -> zoekt het haakje sluiten
        const cleanedText = element.textContent.replace(/\s*\([^)]*\)/g, '');
        
        // Alleen de DOM bijwerken als er echt iets veranderd is
        if (element.textContent !== cleanedText) {
            element.textContent = cleanedText.trim();
        }
    };

    // 2. Functie om alle elementen op de pagina te scannen
    const cleanAllElements = () => {
        // Tooltips op productpagina
        document.querySelectorAll('.tooltip').forEach(removeBrackets);
        
        // Geselecteerde kleurnaam boven de swatches
        document.querySelectorAll('[data-header-option]').forEach(removeBrackets);
        
        // Variant namen in de winkelwagen/checkout
        document.querySelectorAll('.cart-item-variant').forEach(removeBrackets);

        // NIEUW: Actieve filters in de sidebar (bijv. "Wit (Pen)" wordt "Wit")
        document.querySelectorAll('.active-facets__button .text').forEach(removeBrackets);
    };

    // 3. Direct uitvoeren bij laden
    cleanAllElements();

    // 4. MutationObserver: Blijf kijken naar veranderingen 
    const observer = new MutationObserver((mutations) => {
        observer.disconnect(); // Even pauzeren om loops te voorkomen
        cleanAllElements();    // Alles opnieuw opschonen
        startObserving();      // Weer aanzetten
    });

    function startObserving() {
        observer.observe(document.body, { 
            childList: true, 
            subtree: true,
            characterData: true 
        });
    }

    startObserving();
})();